import { useNavigate, useRouter, type ToOptions } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useContext } from 'react'
import logoSoft from '~/assets/logos/logoSoft.svg'
import { Button } from '~/components/ui/button'
import { AuthContext } from '~/utils/context/auth.context'

const NotFoundPage = () => {
  const router = useRouter()
  const navigate = useNavigate()
  const { authenticated } = useContext(AuthContext)

  // Connecté, la racine choisit le premier écran autorisé par les grants v2 (ou l'état zéro grant).
  const primaryDestination: ToOptions['to'] = authenticated ? '/' : '/login'
  const primaryLabel = authenticated ? "Retour à l'accueil" : 'Aller à la connexion'

  const handlePrimaryAction = () => {
    navigate({ to: primaryDestination })
  }

  const handleBackAction = () => {
    if (router.history.canGoBack()) {
      router.history.back()
      return
    }

    navigate({ to: primaryDestination })
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-sidebar px-6 py-10">
      <div className="w-full max-w-xl rounded-4xl border bg-background/90 p-8 shadow-md sm:p-10">
        <div className="flex flex-col items-center text-center">
          <img src={logoSoft} alt="Logo Gozoki" className="mb-6 h-14 w-auto" />

          <p className="mb-3 text-xl font-medium uppercase text-muted-foreground">
            Page introuvable
          </p>

          <h1 className="font-brand text-6xl leading-none font-semibold text-foreground sm:text-8xl">
            404
          </h1>

          <p className="mt-4 max-w-sm text-sm text-muted-foreground sm:text-base">
            Cette page n&apos;existe pas ou n&apos;est plus disponible.
          </p>

          <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
            <Button className="w-full sm:w-auto" size="lg" onClick={handlePrimaryAction}>
              {primaryLabel}
            </Button>

            <Button
              className="w-full sm:w-auto"
              size="lg"
              variant="outline"
              onClick={handleBackAction}
            >
              <ArrowLeft className="size-4" />
              Retour en arrière
            </Button>
          </div>
        </div>
      </div>
    </main>
  )
}

export default NotFoundPage
